import { jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { lazyImport } from "@nxplatform/helpers/helpers";
const { UISnackbarNotificationsPrivate } = lazyImport(
  () => import("./ui-snackbar-notifications.private.js"),
  "UISnackbarNotificationsPrivate"
);
const UISnackbarNotifications = (props) => {
  return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(UISnackbarNotificationsPrivate, { ...props }) });
};
export {
  UISnackbarNotifications
};
